export enum MessageType {
  Text = 'text',
  Photo = 'photo',
  Video = 'video',
  Gif = 'gif',
  File = 'file',
  Poll = 'poll',
  Prayer = 'prayer',
  Media = 'media',
  Bible = 'bible',
  Announcement = 'announcement',
  // Sendbird is accepting only lowercase as type (not capitals or characters)
  GroupEvent = 'groupevent',
}
